export const FAITHS = [
  { id: "all", label: "All Faiths", short: "All" },
  { id: "bible", label: "Bible", short: "Bible" },
  { id: "quran", label: "Qur'an", short: "Qur'an" },
  { id: "torah", label: "Torah", short: "Torah" },
  { id: "gita", label: "Bhagavad Gita", short: "Gita" },
  { id: "buddhist", label: "Buddhist Texts", short: "Buddhist" },
  { id: "mormon", label: "Mormon", short: "Mormon" },
];

export const PROMPTS = [
  { key: "purpose", label: "Purpose", q: "What is my true purpose in life?" },
  { key: "suffering", label: "Suffering", q: "Why do good people suffer?" },
  { key: "love", label: "Love", q: "What is the deepest meaning of love?" },
  { key: "forgiveness", label: "Forgiveness", q: "How do I forgive someone who has hurt me deeply?" },
  { key: "death", label: "Death", q: "What happens to us after we die?" },
  { key: "meaning", label: "Meaning", q: "How do I find meaning when everything feels empty?" },
  { key: "peace", label: "Peace", q: "How can I find inner peace amid chaos?" },
];
